var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Platform"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.2028 33.2648C27.8797 33.5883 27.479 33.75 27.0007 33.75C26.5224 33.75 26.1214 33.5883 25.7978 33.2648C25.4743 32.9414 25.3125 32.5406 25.3125 32.0626L25.3125 10.6874C25.3125 10.2093 25.474 9.80856 25.7971 9.48516C26.1202 9.16172 26.5209 9 26.9992 9C27.4775 9 27.8785 9.16172 28.2021 9.48516C28.5256 9.80856 28.6874 10.2093 28.6874 10.6874L28.6874 32.0626C28.6874 32.5406 28.5258 32.9414 28.2028 33.2648Z",
    fill: "#7C7D79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.2028 44.5148C27.8797 44.8383 27.479 45 27.0007 45C26.5224 45 26.1214 44.8383 25.7978 44.5148C25.4743 44.1914 25.3125 43.7906 25.3125 43.3126L25.3125 39.9374C25.3125 39.4593 25.474 39.0586 25.7971 38.7352C26.1201 38.4117 26.5209 38.25 26.9992 38.25C27.4775 38.25 27.8785 38.4117 28.2021 38.7352C28.5256 39.0586 28.6874 39.4593 28.6874 39.9374L28.6874 43.3126C28.6874 43.7906 28.5258 44.1914 28.2028 44.5148Z",
    fill: "#7C7D79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFoundIcon);
export default __webpack_public_path__ + "static/media/PageNotFoundIcon.4f498d3d4e78b9f16fe5c1b9bb1e8146.svg";
export { ForwardRef as ReactComponent };